import HeroBanner from "./components/HeroBanner";
import CategoryNav from "./components/CategoryNav";
import FeaturedArticles from "./components/FeaturedArticles";
import HomeSidebar from "./components/HomeSidebar";
import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import { siteInfo } from "@/mocks/site-info";

export default function Home() {
  return (
    <>
      <SEOHead
        title={siteInfo.tagline}
      />
      <SchemaOrg type="home" />

      <main>
        <HeroBanner />
        <CategoryNav />
        <FeaturedArticles />
        <HomeSidebar />
      </main>
    </>
  );
}